import { render, staticRenderFns } from "./Estudante-pesquisa-geral.vue?vue&type=template&id=6f795b8a&scoped=true&"
import script from "./Estudante-pesquisa-geral.vue?vue&type=script&lang=js&"
export * from "./Estudante-pesquisa-geral.vue?vue&type=script&lang=js&"
import style0 from "./Estudante-pesquisa-geral.vue?vue&type=style&index=0&id=6f795b8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f795b8a",
  null
  
)

export default component.exports